export const LANDING_BODY_FONT_SIZE = '15px';
